export const transactions = "/transactions"
export const transfers = "/transfers"
export const hedera = "/hedera/:transactionId"
export const transactionDetails = ":transactionId"

export const getTransactionDetailsUrl = (transactionId: string) =>
	`${transfers}/${transactionId}`
